export default function selectAll (selector, el) {
  let parent = el || document
  return [].slice.call(parent.querySelectorAll(selector))
}
